import { render, staticRenderFns } from "./DocumentSplitterPageGrid.vue?vue&type=template&id=6ade5ad0&"
import script from "./DocumentSplitterPageGrid.vue?vue&type=script&lang=js&"
export * from "./DocumentSplitterPageGrid.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSplitterPageGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports